import { gql } from "@apollo/client";
import moment from 'moment';

export const GET_DOCUMENTO_CONTRATO_BY_ID = gql`
query documentoContratoById ($idDocumento: Int! ){
  documentoContratoById(idDocumento: $idDocumento ){
    contentType
    titulo
    archivo
    extension
  }
}`;

export const adaptDocumentoById = (documento) => ({
  contentType: documento?.documentoContratoById?.contentType,
  titulo: documento?.documentoContratoById?.titulo,
  archivo: documento?.documentoContratoById?.archivo,
  extension: documento?.documentoContratoById?.extension
});